import { render, staticRenderFns } from "./start_coach_recom.vue?vue&type=template&id=e77d9a96"
import script from "./start_coach_recom.vue?vue&type=script&lang=js"
export * from "./start_coach_recom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports